import React, { Component } from 'react';

class MasterDataAuditDetail extends Component {
    render() {
        return (
            <div className="w-1/2 p-10 kanan">
                <div className="flex justify-between w-full mb-5">
                    <div className="w-1/6 pr-5 text-right">
                        <label className="select-none font-medium text-gray-400" htmlFor="tslcreatedat">Dibuat</label>
                    </div>
                    <div className="w-5/6">
                        <input
                            type="text"
                            id="tslcreatedat"
                            name="createdAt"
                            className="form-control"
                            defaultValue={this.props.createdAt}
                            disabled
                        />
                    </div>
                </div>
                <div className="flex justify-between w-full mb-5">
                    <div className="w-1/6 pr-5 text-right">
                        <label className="select-none font-medium text-gray-400" htmlFor="tslupdatedat">Diubah</label>
                    </div>
                    <div className="w-5/6">
                        <input
                            type="text"
                            id="tslupdatedat"
                            name="updatedAt"
                            className="form-control"
                            defaultValue={this.props.updatedAt}
                            disabled
                        />
                    </div>
                </div>
                <div className="flex justify-between w-full mb-5">
                    <div className="w-1/6 pr-5 text-right">
                        <label className="select-none font-medium text-gray-400" htmlFor="tslupdatedby">Diubah Oleh</label>
                    </div>
                    <div className="w-5/6">
                        <input
                            type="text"
                            id="tslupdatedby"
                            name="updatedBy"
                            className="form-control"
                            defaultValue={this.props.modifiedBy === "" ? "-" : this.props.modifiedBy}
                            disabled
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default MasterDataAuditDetail;